import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { EnrollResult } from "./EnrollResult";
import { CloseButton } from "../utils/components";
import { StyledModal } from "../utils/styledComponents";
import { EnrollFailed } from "../../../ApplicationFormEditor/components/result/EnrollFailed";
import { sizes } from "../../../../../constant/styles";
import { useEnrollmentTracking } from "../hooks/useEnrollmentTracking";

export const SubmittedFormResultModal = ({
  visible,
  onCancel,
  width = "80vh",
  error = null,
  resultId,
  hideDescription = false,
  titleStyle,
  applicationItemsWithConfirmationId,
  isPatientAlreadyEnrolled
}) => {
  const { t } = useTranslation();
  const { trackPopupImpression, trackButtonClick } = useEnrollmentTracking();

  // Track modal impression when visible
  useEffect(() => {
    if (visible) {
      trackPopupImpression("view_submission_details_modal", {
        popup_title: t("patientApplications.enroll.enroll_result.view_details_title"),
        is_error: !!error,
        has_confirmation_id: !!applicationItemsWithConfirmationId,
        is_patient_already_enrolled: isPatientAlreadyEnrolled
      });
    }
  }, [visible]);

  const handleClose = () => {
    trackButtonClick(
      "view_details_modal_close_button",
      {
        button_id: "EE_submitted_form_modal_close",
        button_text: t("patientApplications.enroll.electronic_signatures.close")
      },
      { contentType: "button", feature: "ee_third_step" }
    );
    onCancel();
  };

  return (
    <StyledModal
      centered
      open={visible}
      width={width}
      footer={
        <div style={{ paddingTop: "16px" }}>
          <CloseButton key="back" onClick={handleClose} id={"EE_submitted_form_modal_close"} />
        </div>
      }
      gap={30}
      bodyStyle={{ marginTop: sizes.xlarge }}
      closable={false}
    >
      {!error && (
        <EnrollResult
          id={resultId}
          hideDescription={hideDescription}
          titleStyle={titleStyle}
          applicationItemsWithConfirmationId={applicationItemsWithConfirmationId}
          isPatientAlreadyEnrolled={isPatientAlreadyEnrolled}
        />
      )}
      {!!error && <EnrollFailed error={error} padding={"0 10rem"} id={resultId} />}
    </StyledModal>
  );
};
